import { render, staticRenderFns } from "./IconTextLogo.vue?vue&type=template&id=06bb3872&"
import script from "./IconTextLogo.vue?vue&type=script&lang=js&"
export * from "./IconTextLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports